// TawkWidgetLoader.jsx
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const TawkWidgetLoader = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useEffect(() => {
    const excludedPaths = [
      "/use-policy-terms",
      "/privacy-policy",
      "/kyc-info"
    ];

    const shouldExclude = excludedPaths.includes(location.pathname) && id === "mobile";

    if (shouldExclude) return;

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = "https://embed.tawk.to/668aee1fe1e4f70f24ee7fcc/1i27b4av9";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    document.body.appendChild(s1);

    return () => {
      // Clean up the script and widget on route change
      const widgetIframe = document.querySelector('iframe[src*="tawk.to"]');
      if (widgetIframe) {
        widgetIframe.parentNode?.remove();
      }
      s1.remove();
    };
  }, [location, id]);

  return null;
};

export default TawkWidgetLoader;
